import React from 'react'
import { Dropdown } from 'semantic-ui-react'
import { map, get, find, filter } from 'lodash'
import { kea } from 'kea'
import PropTypes from "prop-types";
import styled from "styled-components";
import { apply, select, put } from 'redux-saga/effects'
import parseLinkHeader from 'parse-link-header'

import { __ } from '~/i18n'
import { API } from '@gratify-eu/api-client'
import { selector as configSelector } from '~/config'
import entities from '~/entities'


const DropdownOption = styled.span``;
const DropdownOptionDescription = styled.span`
  margin-left: 10px;
  color: #868686;
`;


class ParcelMachine extends React.PureComponent {
  constructor(props) {
    super(props);

    this.setSelectedPlace(props)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(prevProps.selectedPlace !== this.props.selectedPlace) {
      this.setSelectedPlace(this.props);
    }
  }

  setSelectedPlace = (props) => {
    const { selectedPlace, setOptions } = props;

    if(setOptions) {
      setOptions(selectedPlace && selectedPlace.id ? {
        place_id: selectedPlace.id,
        place: selectedPlace
      } : null)
    }
  };

  handleChange = (e, {value}) => {
    const { places } = this.props;
    const { selectPlace } = this.props.actions;

    selectPlace(find(places, {id: value}));
  };

  getOptions = () => {
    const { places, placeFormatter } = this.props;
    return map(filter(places, {active: true}), placeFormatter);
  };

  render() {
    const { loading, selectedPlace, placeholder, error, ...restProps } = this.props;

    return (
      <Dropdown
        fluid
        selection
        search={ true }
        value={selectedPlace && selectedPlace.id}
        options={ this.getOptions() }
        onChange={this.handleChange}
        disabled={loading}
        loading={loading}
        placeholder={ placeholder || __('Search for a parcel machine') }
        error={ error }
      />
    )
  }
}


const ParcelMachineSelect = kea({
  connect: {
    values: [
      entities, [
        'activeCart'
      ]
    ]
  },
  actions: () => ({
    setLoading: true,
    clearLoading: true,
    receivePlaces: (places) => ({places}),
    selectPlace: (place) => ({place}),
    clearPlace: true,
  }),

  reducers: ({ actions, constants }) => ({
    loading: [false, PropTypes.bool, {
      [actions.setLoading]: () => (true),
      [actions.clearLoading]: () => (false),
    }],
    places: [[], PropTypes.array, {
      [actions.receivePlaces]: (_, payload) => {
        const { places } = payload || {};

        return places;
      },
    }],
    selectedPlace: [null, PropTypes.object, {
      [actions.selectPlace]: (_, payload) => (payload.place),
      [actions.clearPlace]: () => null
    }]
  }),

  start: function * () {
    const { method } = this.props;
    const { receivePlaces, setLoading, clearLoading, selectPlace, clearPlace } = this.actionCreators;
    const activeCart = yield this.get('activeCart');
    if(method) {
      const { choices_url } = method || {};
      if(choices_url) {
        try {
          yield put(setLoading());
          yield put(clearPlace());
          const config = yield select(configSelector);
          const api = new API(config);
          let places = [];
          let response, linkHeader, parsedLinkHeader;
          response = yield apply(api, api.call, [choices_url, 'GET']);
          linkHeader = get(response, 'headers.link');
          if(linkHeader) {
            parsedLinkHeader = parseLinkHeader(linkHeader);
          }
          places = [...places, ...response.data];
          while(parsedLinkHeader && parsedLinkHeader.next && parsedLinkHeader.next.url) {
            response = yield apply(api, api.call, [parsedLinkHeader.next.url, 'GET']);
            linkHeader = get(response, 'headers.link');
            if(linkHeader) {
              parsedLinkHeader = parseLinkHeader(linkHeader);
            }else {
              parsedLinkHeader = null;
            }
            places = [...places, ...response.data];
          }

          yield put(receivePlaces(places));

          const placeId = get(activeCart, 'shipping_method_options.place_id', null);
          if(placeId) {
            const place = find(places, {id: placeId});
            if(place) {
              yield put(selectPlace(place));
            }
          }

          yield put(clearLoading());
        } catch(e) {
          console.error(e);
          yield put(clearLoading());
        }
      }
    }
  }
})(ParcelMachine);

ParcelMachineSelect.OmnivaPlaceFormatter = (place) => {
  return {
    key: place.id,
    value: place.id,
    text: `${place.name} - ${place.a1_name}`,
    content: <DropdownOption>{ place.name } <DropdownOptionDescription>{ place.a1_name }</DropdownOptionDescription></DropdownOption>
  }
};

ParcelMachineSelect.SmartpostPlaceFormatter = (place) => {
  return {
    key: place.id,
    value: place.id,
    text: `${place.name} - ${place.group_name}`,
    content: <DropdownOption>{ place.name } <DropdownOptionDescription>{ place.group_name }</DropdownOptionDescription></DropdownOption>
  }
};

ParcelMachineSelect.DPDPlaceFormatter = (place) => {
  return {
    key: place.id,
    value: place.id,
    text: `${place.name} - ${place.group_name}`,
    content: <DropdownOption>{ place.name } <DropdownOptionDescription>{ place.group_name }</DropdownOptionDescription></DropdownOption>
  }
};

ParcelMachineSelect.defaultProps = {
  placeFormatter: ParcelMachineSelect.SmartpostPlaceFormatter
};



export default ParcelMachineSelect
